import type React from "react";
import {Tooltip} from "@mui/material";
import {Tag} from "~/components/tag/Tag.tsx";
import type {Gap} from "../contractExplorerTypes.ts";
import {sortGaps} from "../contractExplorerFormat.ts";

/**
 * Needs attention, to its own hierarchy: an action gap (linkage could not
 * finish) is a filled pill, a watch gap a quiet outlined tag. Not every gap
 * is an alert.
 */
export const GapTags: React.FC<{gaps: Gap[]; max?: number}> = ({gaps, max = 2}) => {
    if (!gaps.length) return <span className="ci-dash">—</span>;
    const sorted = sortGaps(gaps);
    const rest = sorted.slice(max);
    return (
        <span className="ci-gaptags">
            {sorted.slice(0, max).map(gap => (
                <Tooltip key={gap.key} arrow title={gap.note}>
                    <span>
                        <Tag label={gap.label}
                             color={gap.severity === 'action' ? 'error' : 'default'}
                             variant={gap.severity === 'action' ? 'filled' : 'outlined'}/>
                    </span>
                </Tooltip>
            ))}
            {rest.length > 0 && (
                <Tooltip arrow title={rest.map(g => g.label).join(' · ')}>
                    <span className="ci-csub">+{rest.length}</span>
                </Tooltip>
            )}
        </span>
    );
};
